import CircularProgress from './circularProgress';

export default CircularProgress;